import i18n from 'i18next'

export const getHeaderBarData = () => {
    return [
        // { name: i18n.t('Home'), link: '/home' },
        
    ];
}